var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function(n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
__name(_extends, "_extends");
import React from "react";
import Icon from "@ant-design/icons";
var ReviewsSvg = /* @__PURE__ */ __name(function ReviewsSvg2() {
  return /* @__PURE__ */ React.createElement("svg", {
    width: "100%",
    height: "100%",
    viewBox: "0 0 180 29",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    }
  }, /* @__PURE__ */ React.createElement("rect", {
    id: "reviewsio-logo--black",
    x: "0",
    y: "0",
    width: "180",
    height: "29",
    style: {
      fill: "none"
    }
  }), /* @__PURE__ */ React.createElement("g", {
    id: "reviewsio-logo"
  }, /* @__PURE__ */ React.createElement("path", {
    d: "M39.149,14.327c2.945,0 5.049,-1.515 5.049,-4.039l0,-0.056c0,-2.412 -1.852,-3.871 -5.021,-3.871l-6.058,0l0,7.966l6.03,0Zm-8.245,-8.891c0,-0.617 0.505,-1.122 1.094,-1.122l7.348,0c2.411,0 4.347,0.729 5.581,1.963c0.953,0.954 1.514,2.328 1.514,3.871l0,0.055c0,3.226 -2.188,5.105 -5.245,5.694l4.881,6.283c0.224,0.251 0.364,0.504 0.364,0.812c0,0.59 -0.561,1.095 -1.122,1.095c-0.449,0 -0.785,-0.253 -1.037,-0.59l-5.526,-7.179l-5.637,0l0,6.647c0,0.617 -0.505,1.122 -1.121,1.122c-0.589,0 -1.094,-0.505 -1.094,-1.122l0,-17.529Z",
    style: {
      filRule: "nonzero"
    }
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M50.899,22.825l0,-17.389c0,-0.617 0.505,-1.122 1.094,-1.122l12.2,0c0.56,0 1.01,0.449 1.01,1.01c0,0.561 -0.45,1.01 -1.01,1.01l-11.079,0l0,6.702l9.817,0c0.561,0 1.01,0.477 1.01,1.01c0,0.561 -0.449,1.009 -1.01,1.009l-9.817,0l0,6.872l11.219,0c0.561,0 1.009,0.449 1.009,1.009c0,0.561 -0.448,1.01 -1.009,1.01l-12.34,0c-0.589,0 -1.094,-0.505 -1.094,-1.121",
    style: {
      filRule: "nonzero"
    }
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M75.716,23.245l-7.572,-17.473c-0.084,-0.168 -0.113,-0.308 -0.113,-0.505c0,-0.56 0.505,-1.093 1.123,-1.093c0.56,0 0.953,0.364 1.149,0.841l6.788,16.266l6.814,-16.322c0.197,-0.392 0.59,-0.785 1.094,-0.785c0.617,0 1.094,0.505 1.094,1.066c0,0.168 -0.028,0.308 -0.084,0.448l-7.601,17.557c-0.252,0.561 -0.645,0.926 -1.29,0.926l-0.112,0c-0.645,0 -1.066,-0.365 -1.29,-0.926",
    style: {
      filRule: "nonzero"
    }
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M90.186,5.296c0,-0.617 0.505,-1.122 1.094,-1.122c0.616,0 1.121,0.505 1.121,1.122l0,17.669c0,0.617 -0.505,1.122 -1.121,1.122c-0.589,0 -1.094,-0.505 -1.094,-1.122l0,-17.669Z",
    style: {
      filRule: "nonzero"
    }
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M97.869,22.825l0,-17.389c0,-0.617 0.505,-1.122 1.093,-1.122l12.201,0c0.56,0 1.01,0.449 1.01,1.01c0,0.561 -0.45,1.01 -1.01,1.01l-11.079,0l0,6.702l9.816,0c0.562,0 1.01,0.477 1.01,1.01c0,0.561 -0.448,1.009 -1.01,1.009l-9.816,0l0,6.872l11.219,0c0.56,0 1.009,0.449 1.009,1.009c0,0.561 -0.449,1.01 -1.009,1.01l-12.341,0c-0.588,0 -1.093,-0.505 -1.093,-1.121",
    style: {
      filRule: "nonzero"
    }
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M115.198,5.801c-0.056,-0.168 -0.111,-0.336 -0.111,-0.505c0,-0.589 0.532,-1.121 1.149,-1.121c0.561,0 0.982,0.42 1.15,0.924l5.413,15.595l5.132,-15.65c0.168,-0.505 0.505,-0.869 1.094,-0.869l0.141,0c0.56,0 0.925,0.364 1.093,0.869l5.132,15.65l5.441,-15.65c0.169,-0.505 0.533,-0.869 1.066,-0.869c0.589,0 1.122,0.532 1.122,1.093c0,0.168 -0.085,0.365 -0.14,0.533l-6.283,17.444c-0.196,0.561 -0.588,0.954 -1.15,0.954l-0.168,0c-0.56,0 -0.953,-0.393 -1.149,-0.954l-5.105,-15.088l-5.077,15.088c-0.195,0.561 -0.588,0.954 -1.149,0.954l-0.168,0c-0.561,0 -0.954,-0.365 -1.15,-0.954l-6.283,-17.444Z",
    style: {
      filRule: "nonzero"
    }
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M145.793,21.591c-0.252,-0.169 -0.421,-0.478 -0.421,-0.842c0,-0.617 0.478,-1.094 1.067,-1.094c0.28,0 0.533,0.112 0.672,0.252c1.851,1.572 3.703,2.329 6.199,2.329c2.636,0 4.375,-1.403 4.375,-3.338l0,-0.056c0,-1.823 -0.982,-2.86 -5.104,-3.73c-4.516,-0.981 -6.592,-2.44 -6.592,-5.666l0,-0.055c0,-3.085 2.721,-5.357 6.451,-5.357c2.581,0 4.459,0.645 6.254,1.935c0.225,0.169 0.477,0.477 0.477,0.897c0,0.59 -0.477,1.066 -1.065,1.066c-0.253,0 -0.45,-0.056 -0.645,-0.196c-1.655,-1.206 -3.254,-1.711 -5.077,-1.711c-2.552,0 -4.179,1.402 -4.179,3.169l0,0.056c0,1.852 1.01,2.889 5.329,3.815c4.375,0.954 6.394,2.551 6.394,5.552l0,0.057c0,3.365 -2.804,5.553 -6.702,5.553c-2.861,0 -5.245,-0.898 -7.433,-2.636",
    style: {
      filRule: "nonzero"
    }
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M163.245,21.727c0.423,0 0.737,0.313 0.737,0.737l0,0.314c0,0.424 -0.314,0.753 -0.737,0.753c-0.439,0 -0.753,-0.329 -0.753,-0.753l0,-0.314c0,-0.424 0.314,-0.737 0.753,-0.737",
    style: {
      filRule: "nonzero"
    }
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M166.619,15.876c0,-0.329 0.267,-0.612 0.596,-0.612c0.345,0 0.612,0.266 0.612,0.612l0,7.043c0,0.345 -0.251,0.612 -0.597,0.612c-0.344,0 -0.611,-0.267 -0.611,-0.612l0,-7.043Zm-0.11,-3.074c0,-0.393 0.314,-0.644 0.706,-0.644c0.408,0 0.721,0.251 0.721,0.644l0,0.203c0,0.377 -0.313,0.643 -0.721,0.643c-0.392,0 -0.706,-0.266 -0.706,-0.643l0,-0.203Z",
    style: {
      filRule: "nonzero"
    }
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M177.35,19.437l0,-0.031c0,-1.741 -1.302,-3.17 -3.012,-3.17c-1.757,0 -2.965,1.429 -2.965,3.139l0,0.031c0,1.741 1.287,3.152 2.997,3.152c1.756,0 2.98,-1.411 2.98,-3.121m-7.216,0l0,-0.031c0,-2.29 1.789,-4.236 4.236,-4.236c2.431,0 4.219,1.914 4.219,4.205l0,0.031c0,2.29 -1.803,4.235 -4.251,4.235c-2.431,0 -4.204,-1.914 -4.204,-4.204",
    style: {
      filRule: "nonzero"
    }
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M1,14.193c0,6.733 5.459,12.192 12.192,12.192c6.734,0 12.193,-5.459 12.193,-12.192c0,-6.734 -5.459,-12.193 -12.193,-12.193c-6.733,0 -12.192,5.459 -12.192,12.193Zm8.486,2.205c0.128,-0.405 -0.014,-0.847 -0.355,-1.102c-0.902,-0.674 -2.682,-2.003 -3.877,-2.895c-0.173,-0.129 -0.243,-0.354 -0.175,-0.559c0.068,-0.204 0.259,-0.342 0.474,-0.342l4.634,0c0.431,0 0.814,-0.276 0.949,-0.686c0.365,-1.103 1.091,-3.296 1.573,-4.749c0.067,-0.204 0.258,-0.342 0.474,-0.343c0.215,0 0.406,0.138 0.475,0.342c0.486,1.454 1.221,3.65 1.59,4.753c0.136,0.408 0.518,0.683 0.948,0.683c1.096,0 3.208,0 4.645,0c0.215,0 0.406,0.137 0.474,0.341c0.068,0.204 -0.001,0.429 -0.173,0.558c-1.192,0.898 -2.972,2.239 -3.873,2.917c-0.338,0.255 -0.479,0.696 -0.351,1.101c0.348,1.1 1.046,3.305 1.518,4.794c0.066,0.209 -0.011,0.436 -0.19,0.561c-0.178,0.125 -0.418,0.12 -0.591,-0.013c-1.198,-0.919 -2.947,-2.262 -3.863,-2.965c-0.36,-0.276 -0.861,-0.275 -1.22,0.002c-0.908,0.702 -2.633,2.036 -3.82,2.954c-0.173,0.134 -0.413,0.14 -0.592,0.015c-0.18,-0.126 -0.257,-0.353 -0.191,-0.561c0.472,-1.494 1.169,-3.703 1.517,-4.806Z",
    style: {
      filRule: "nonzero"
    }
  })));
}, "ReviewsSvg");
var ReviewsIcon = /* @__PURE__ */ __name(function ReviewsIcon2(props) {
  return /* @__PURE__ */ React.createElement(Icon, _extends({
    component: ReviewsSvg
  }, props));
}, "ReviewsIcon");
export {
  ReviewsIcon
};
